import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiMainSettingsService {

  attributesSwitchubject = new Subject<any>();

  constructor() { }

  /**
   * 
   * @param data 
   */
   switchTab(data: string): void {

    this.attributesSwitchubject.next(data);
  }

   /**
   * Method to listen for language change
   * @returns Observable<any>
   */
    listenerSwitchTab(): Observable<any> {

      return this.attributesSwitchubject.asObservable();
    }
}
